var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"p-3 mb-3 mt-2 rounded bg-white",attrs:{"fluid":"xl"}},[_c('b-row',[_c('b-col',[_vm._t("default",function(){return [_vm._v("   ")]})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }